"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.QuickFilter = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledQuickFilter = require("./styled-quick-filter");
var _excluded = ["label", "image", "link", "className", "clickCallback", "dataAnalyticsId", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback;
var propTypes = {
  label: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].shape({
    dataTestId: _propTypes["default"].string,
    isLazy: _propTypes["default"].bool,
    imageLink: _propTypes["default"].string.isRequired
  }),
  link: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  clickCallback: _propTypes["default"].func,
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
var defaultProps = {
  className: 'fuse-quick-filter',
  clickCallback: undefined,
  dataAnalyticsId: undefined,
  dataTestId: 'fuse-quick-filter-test-id',
  image: {}
};
var QuickFilter = exports.QuickFilter = forwardRef(function (_ref, ref) {
  var label = _ref.label,
    image = _ref.image,
    link = _ref.link,
    className = _ref.className,
    clickCallback = _ref.clickCallback,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataTestId = _ref.dataTestId,
    others = _objectWithoutProperties(_ref, _excluded);
  var imageDataTestId = image.dataTestId,
    isLazy = image.isLazy,
    imageLink = image.imageLink;
  var clickHandler = useCallback(function (e) {
    if (typeof clickCallback === 'function') clickCallback(e, ref);
  }, [clickCallback]);
  return /*#__PURE__*/_react["default"].createElement(_styledQuickFilter.StyledQuickFilter, _extends({}, others, {
    className: className,
    "data-analyticsid": dataAnalyticsId,
    "data-testid": dataTestId,
    href: link,
    onClick: clickHandler,
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_styledQuickFilter.StyledImage, _extends({
    dataTestId: imageDataTestId,
    fallbackSource: imageLink,
    isLazy: isLazy
  }, image)), /*#__PURE__*/_react["default"].createElement(_styledQuickFilter.StyledLabel, null, label));
});
QuickFilter.propTypes = propTypes;
QuickFilter.defaultProps = defaultProps;
var _default = exports["default"] = QuickFilter;